"use client";
import { Fragment } from 'react';
import Footer from "@/components/footer";
import Header from "@/components/header";
import NewHeader from "@/components/new_header";
import LastService from "@/components/lastService";
import LastServiceOther from "@/components/lastServiceOther";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import StyledComponentsRegistry from "@/utils/lib/AntdRegistry";
import {serviceList ,path } from "@/constants/common";
import "swiper/css";
import 'swiper/css/effect-fade';
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/scss/autoplay";
import "./globals.scss";

// export const metadata = {
//   title: "智语",
//   description: "智语",
// };
export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathName = usePathname();
  function getSuffix(){
    return process.env.CURRENT_ENV=="production"?".html":""
  }
  function changeRem() {
    const screenWidth = 1920;

    const htmlWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
   if(htmlWidth>1023){
    return
   }
    const scale = screenWidth / 12.8;
    const htmlDom = document.getElementsByTagName("html")[0];
    if (htmlWidth < 1601) {
      htmlDom.style.fontSize = "11.2px"; //
    }else if(htmlWidth < 900){
      htmlDom.style.fontSize = "9px";
    } else {
      htmlDom.style.fontSize = htmlWidth / scale + "px";
    }
  }

  useEffect(() => {
    // changeRem();
    // window.addEventListener("resize", changeRem);

    // 在线客服
    var _hmt: any = _hmt || [];
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?4b4a0bfc97fd28a4454369f4d9ba5967";
    var s: any = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
    // end
    // return () => {
    //   window.removeEventListener("resize", changeRem);
    // };
  }, []);
  const isFooter = pathName.indexOf("register") == -1;
  const isHeader = pathName.indexOf("registersuccess") == -1;
  return (
    <html lang="en">
      <body className="body-box">
      <StyledComponentsRegistry>
      <Fragment>
        {isHeader && <NewHeader />}
        {children}
        {
          isFooter && (serviceList.some(n => (path + n + getSuffix()) == pathName) ? <LastServiceOther /> : <LastService />)
        }
        {isFooter && <Footer />}
        </Fragment>
        </StyledComponentsRegistry>
        
      </body>
    </html>
  );
}
